module.exports = __webpack_public_path__ + "img/answers-card-question.058d3d5f.svg";